var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup48095512(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 54,
    viewBox: "0 0 29 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 27,
    r: 26,
    fill: "#FDFFE6",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38036 12.3226H0.768921V41.6773H4.38036C10.7972 41.6774 16 35.1058 16 27C16 18.8942 10.7972 12.3226 4.38036 12.3226Z",
    fill: "url(#paint0_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38036 12.3226H0.768921V41.6773H4.38036C10.7972 41.6774 16 35.1058 16 27C16 18.8942 10.7972 12.3226 4.38036 12.3226Z",
    fill: "url(#paint1_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.768799 41.6774H4.38024C10.7972 41.6774 16 35.1058 16 27C16 26.2823 15.9584 25.577 15.8796 24.8868H0.768799V41.6774Z",
    fill: "url(#paint2_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.768854 41.6774C7.18616 41.6774 12.3884 35.1061 12.3884 27.0001C12.3884 18.8941 7.18616 12.3229 0.768854 12.3229C-5.64845 12.3229 -10.8507 18.8941 -10.8507 27.0001C-10.8507 35.1061 -5.64845 41.6774 0.768854 41.6774Z",
    fill: "url(#paint3_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.892542 26.3922H-10.84C-10.8465 26.5939 -10.8507 26.7964 -10.8507 27.0001C-10.8507 35.1061 -5.64846 41.6773 0.768854 41.6773C4.62417 41.6773 8.04029 39.305 10.154 35.6536L0.892542 26.3922Z",
    fill: "url(#paint4_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.8507 27C-10.8507 35.1061 -5.64846 41.6773 0.768854 41.6773C7.18617 41.6773 12.3884 35.1061 12.3884 27C12.3884 26.7065 12.3808 26.4152 12.3674 26.1259H-10.8296C-10.8431 26.4152 -10.8507 26.7065 -10.8507 27Z",
    fill: "url(#paint5_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.768822 12.3228C0.116384 12.3228 -0.523115 12.3918 -1.14624 12.5223V41.4778C-0.523115 41.6083 0.116447 41.6773 0.768822 41.6773C7.18613 41.6773 12.3884 35.1061 12.3884 27.0001C12.3884 18.8941 7.18613 12.3228 0.768822 12.3228Z",
    fill: "url(#paint6_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.768824 14.9426C-4.50268 14.9426 -8.77649 20.3413 -8.77649 27C-8.77649 33.6588 -4.50268 39.0574 0.768824 39.0574C6.04032 39.0574 10.3142 33.6588 10.3142 27C10.3142 20.3413 6.04039 14.9426 0.768824 14.9426ZM0.768824 36.6463C-3.44868 36.6463 -6.86774 32.3271 -6.86774 27C-6.86774 21.6729 -3.44868 17.3537 0.768824 17.3537C4.98632 17.3537 8.40539 21.6728 8.40539 27C8.40539 32.3272 4.98632 36.6463 0.768824 36.6463Z",
    fill: "url(#paint7_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.768809 19.9695C-2.30532 19.9695 -4.79675 23.1171 -4.79675 27C-4.79675 30.8829 -2.30532 34.0305 0.768809 34.0305C3.84293 34.0305 6.33444 30.8829 6.33444 27C6.33444 23.1171 3.84293 19.9695 0.768809 19.9695ZM0.768809 31.2127C-1.07332 31.2127 -2.56644 29.3265 -2.56644 27C-2.56644 24.6734 -1.07338 22.7873 0.768809 22.7873C2.611 22.7873 4.10406 24.6734 4.10406 27C4.10406 29.3265 2.611 31.2127 0.768809 31.2127Z",
    fill: "url(#paint8_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64187 29.1413C3.06125 30.3813 1.99187 31.2126 0.768749 31.2126C-1.07313 31.2126 -2.56625 29.3263 -2.56625 27.0001C-2.56625 26.7932 -2.55437 26.5901 -2.53187 26.392H-4.77563C-4.79 26.5926 -4.79688 26.7951 -4.79688 27.0001C-4.79688 30.8832 -2.305 34.0307 0.768749 34.0307C2.70125 34.0307 4.40312 32.7876 5.4 30.8995L3.64187 29.1413Z",
    fill: "url(#paint9_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0275 32.5275C5.64688 35.0181 3.35813 36.6462 0.768754 36.6462C-3.44875 36.6462 -6.8675 32.3268 -6.8675 27C-6.8675 26.7956 -6.8625 26.5931 -6.8525 26.3918H-8.76437C-8.7725 26.5931 -8.77625 26.7962 -8.77625 27C-8.77625 33.6587 -4.5025 39.0575 0.768754 39.0575C3.965 39.0575 6.79375 37.0731 8.52688 34.0268L7.0275 32.5275Z",
    fill: "url(#paint10_linear_715_337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13394 27V27.009C1.13356 27.487 0.745874 27.8744 0.267813 27.8744H-15.1256C-15.6085 27.8744 -16 27.4829 -16 27C-16 26.5171 -15.6085 26.1256 -15.1256 26.1256H0.267876C0.745937 26.1256 1.13356 26.5129 1.134 26.991L1.13394 27Z",
    fill: "url(#paint11_linear_715_337)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_337",
    x1: 8.38448,
    y1: 13.4884,
    x2: 8.38448,
    y2: 42.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_337",
    x1: 8.34223,
    y1: 29.0936,
    x2: 15.3956,
    y2: 32.1794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2343,
    stopColor: "#F90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    stopColor: "#EA035B",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#D20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_337",
    x1: 8.38442,
    y1: 27.8157,
    x2: 8.38442,
    y2: 40.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2343,
    stopColor: "#F90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    stopColor: "#EA035B",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#D20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_337",
    x1: -7.62783,
    y1: 22.1698,
    x2: 10.5935,
    y2: 32.6519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_337",
    x1: -0.37102,
    y1: 32.5972,
    x2: -2.06408,
    y2: 26.9388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2343,
    stopColor: "#F90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    stopColor: "#EA035B",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#D20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_337",
    x1: 0.768854,
    y1: 34.3549,
    x2: 0.768854,
    y2: 42.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2343,
    stopColor: "#F90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    stopColor: "#EA035B",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#D20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_337",
    x1: 4.98026,
    y1: 29.7965,
    x2: 11.0785,
    y2: 35.0131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2343,
    stopColor: "#F90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5173,
    stopColor: "#EA035B",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#D20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_337",
    x1: -6.12893,
    y1: 23.0319,
    x2: 8.83957,
    y2: 31.6429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_337",
    x1: -3.25319,
    y1: 24.6862,
    x2: 5.47481,
    y2: 29.7072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_337",
    x1: 0.262812,
    y1: 29.531,
    x2: -0.747063,
    y2: 26.4419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_337",
    x1: -3.73118,
    y1: 30.7668,
    x2: -5.72125,
    y2: 29.1628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_337",
    x1: -7.433,
    y1: 26.3385,
    x2: -7.433,
    y2: 27.4161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48095512);
export default __webpack_public_path__ + "static/media/Group 48095512.07d4a934d42f1c9dd77e900ca6527da9.svg";
export { ForwardRef as ReactComponent };